import {
	ICountryValues,
	CountryValuesProductType,
} from 'shared/constants/countryValueTypes'

export const countryValues: ICountryValues[] = [
	{
		country: 'at',
		tfFullName: 'TF Bank AB',
		copyRight: 'TF Bank AB',
		address: {
			companyName: 'TF Bank AB',
			addressLine1: 'Postfach 0018',
			zipCodeAndCity: '2340 Mödling',
			country: 'Österreich',
		},
		links: () => {
			return {
				legal: {
					title: 'LegalInformation',
					link: 'https://tfbank.at/impressum',
				},
				dataProtection: {
					title: 'DataProtectionFooterTitle',
					link: 'https://tfbank.at/datenschutz',
				},
				faq: {
					title: 'Service',
					link: 'https://tfbank.at/service',
				},
				cookie: {
					title: 'Cookies',
					link: 'https://tfbank.at/cookies',
				},
			}
		},
		productSpecific: [
			{
				productType: CountryValuesProductType.Card,
				contactInformation: {
					email: 'service@tfbank.at',
					openingHours:
						'9:00 - 17:00 Monday - Thursday / 9:00 - 16:00 Friday',
				},
				bankInformation: {
					iban: 'DE77512202000070508402',
					bic: 'ESSEDEFFXXX',
				},
			},
		],
	},
	{
		country: 'de',
		tfFullName: 'TF Bank AB',
		copyRight: 'TF Bank AB',
		address: {
			companyName: 'TF Bank AB',
			addressLine1: 'Postfach 11 02 28',
			zipCodeAndCity: '10823, Berlin',
			country: 'Deutschland',
		},
		links: () => {
			return {
				legal: {
					title: 'LegalInformation',
					link: 'https://tfbank.de/impressum',
				},
				dataProtection: {
					title: 'DataProtection',
					link: 'https://tfbank.de/datenschutz',
				},
				faq: {
					title: 'Service',
					link: 'https://tfbank.de/service',
				},
				cookie: {
					title: 'Cookies',
					link: 'https://tfbank.de/cookies',
				},
			}
		},
		productSpecific: [
			{
				productType: CountryValuesProductType.Card,
				contactInformation: {
					email: 'service@tfbank.de',
					openingHours:
						'9:00 - 17:00 Monday - Thursday / 9:00 - 16:00 Friday',
				},
				bankInformation: {
					iban: 'DE77512202000070508402',
					bic: 'ESSEDEFFXXX',
				},
			},
			{
				productType: CountryValuesProductType.Deposit,
				contactInformation: {
					email: 'tagesgeld@tfbank.de',
					openingHours:
						'9:00 - 17:00 Monday - Thursday / 9:00 - 16:00 Friday',
				},
				bankInformation: {
					iban: 'DE06202208000000024118',
					bic: 'SXPYDEHH',
				},
			},
			{
				productType: CountryValuesProductType.Deposit_Fixed,
				contactInformation: {
					email: 'festgeld@tfbank.de',
					openingHours:
						'9:00 - 17:00 Monday - Thursday / 9:00 - 16:00 Friday',
				},
				bankInformation: {
					iban: 'DE06202208000000024118',
					bic: 'SXPYDEHH',
				},
			},
		],
	},
	{
		country: 'es',
		tfFullName: 'TF Bank AB',
		copyRight: 'TF Bank AB',
		address: {
			companyName: 'TF Bank AB',
			addressLine1: 'Box 947, 501 10 Borås',
			zipCodeAndCity: 'Teléfono: 91 993 10 15 / 900 968 008',
			country: 'Email: clientes.tarjeta@tfbank.es',
		},
		links: () => {
			return {
				legal: {
					title: 'LegalInformation',
					link: 'https://tfbank.de/impressum',
				},
				dataProtection: {
					title: 'DataProtection',
					link: 'https://tfbank.de/datenschutz',
				},
				faq: {
					title: 'Service',
					link: 'https://tfbank.de/service',
				},
				cookie: {
					title: 'Cookies',
					link: 'https://tfbank.de/cookies',
				},
			}
		},
		productSpecific: [
			{
				productType: CountryValuesProductType.Card,
				contactInformation: {
					email: '',
					openingHours:
						'9:00 - 17:00 Monday - Thursday / 9:00 - 16:00 Friday',
				},
				bankInformation: {
					iban: 'DE77512202000070508402',
					bic: 'ESSEDEFFXXX',
				},
			},
		],
	},
	{
		country: 'it',
		tfFullName: 'TF Bank AB',
		copyRight: 'TF Bank AB',
		address: {
			companyName: 'TF Bank AB',
			addressLine1: 'Box 947, 501 10 Borås',
			zipCodeAndCity: 'Tel: 02 555 000/ 800 580 669',
			country: 'Email: info@tfbank.it',
		},
		links: () => {
			return {
				legal: {
					title: 'LegalInformation',
					link: 'https://tfbank.de/impressum',
				},
				dataProtection: {
					title: 'DataProtection',
					link: 'https://tfbank.de/datenschutz',
				},
				faq: {
					title: 'Service',
					link: 'https://tfbank.de/service',
				},
				cookie: {
					title: 'Cookies',
					link: 'https://tfbank.de/cookies',
				},
			}
		},
		productSpecific: [
			{
				productType: CountryValuesProductType.Card,
				contactInformation: {
					email: '',
					openingHours:
						'9:00 - 17:00 Monday - Thursday / 9:00 - 16:00 Friday',
				},
				bankInformation: {
					iban: 'DE77512202000070508402',
					bic: 'ESSEDEFFXXX',
				},
			},
		],
	},
	{
		country: 'no',
		tfFullName: 'TF Bank Norge',
		copyRight: 'TF Bank AB, Sverige',

		links: () => {
			return {
				cookie: { link: 'https://www.tfbank.no/personvernerklaring/' },
				faq: { link: 'https://tfbank.no/hjelp' },
			}
		},
		address: {
			companyName: 'TF Bank Norge',
			addressLine1: 'Postboks 956 Sentrum',
			zipCodeAndCity: '5808, Bergen',
		},
		productSpecific: [
			{
				productType: CountryValuesProductType.Card,
				contactInformation: {
					email: 'kort@tfbank.no',
					phoneNumber: '56 99 92 00',
					openingHours:
						'Mandag - Torsdag: 09:00-17:00 / Fredag: 09:00-16:00',
				},
			},
			{
				productType: CountryValuesProductType.Deposit,
				contactInformation: {
					email: 'innskudd@tfbank.no',
					phoneNumber: '56 99 92 00',
					openingHours:
						'Mandag - Torsdag: 09:00-17:00 / Fredag: 09:00-16:00',
				},
			},
			{
				productType: CountryValuesProductType.Loan,
				contactInformation: {
					email: 'post@tfbank.no',
				},
			},
		],
	},
]
